<template>
  <div fluid class="ma-0 pa-0">
    <div v-if="!showAll && Boolean(replies.length)">
      <div class="pa-0" @click="$emit('expand-change', !expand)" style="cursor: pointer; font-size: 12px;">
        <v-icon size="small" :class="{ expanded: expand, 'expand-icon': true }"
        >mdi-menu-down
        </v-icon
        >
        {{ expand ? "Hide " : "Show " }}
        {{ replies.length }}
        {{ replies.length === 1 ? " reply" : " replies" }}
      </div>
    </div>

    <v-expand-transition @after-enter="$emit('expand-transition-after')" @after-leave="$emit('expand-transition-after')">
      <div v-show="expand">
        <div class="ma-0 pa-0" :class="{'pt-3': !!sortedReplies?.length}">
          <card-reply
            v-for="reply in sortedReplies"
            class="mb-4"
            :key="reply.id"
            :card-id="cardId"
            :reply-form-visible="replyFormVisible"
            :reply="reply"
            :with-dates="withDates"
            :hideAvatar="hideAvatar"
            :currentUser="currentUser"
            :mini-mode="miniMode"
            @hide-reply-form="$emit('hide-reply-form')"
          ></card-reply>

          <div class="mt-3" v-if="replyFormVisible && !$store.state.isWorkflowDisabled">
            <card-reply
              class="mb-4"
              :card-id="cardId"
              :reply-form-visible="replyFormVisible"
              :reply="dummyReply"
              :with-dates="withDates"
              :hideAvatar="hideAvatar"
              :mini-mode="miniMode"
              @ask-for-reply="$emit('ask-for-reply', $event)"
              @hide-reply-form="$emit('hide-reply-form')"
            ></card-reply>
          </div>
          <div
            v-else-if="!miniMode"
            class="d-flex align-center justify-end"
          >
            <v-btn
              icon="mds:add"
              :disabled="$store.state.isWorkflowDisabled"
              @click="$emit('open-replies')"
            />
          </div>
        </div>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
import CardReply from '@/components/CardReply'
import { mapState } from 'vuex'
import store from '../store'

export default {
  components: {
    CardReply
  },

  props: ['cardId', 'showAll', 'expand', 'replyFormVisible', 'replies', 'withDates', 'hideAvatar', 'showAi', 'miniMode'],

  computed: {
    ...mapState({
      currentUser: state => state.user.user
    }),
    sortedReplies () {
      const sortedArray = [...this.replies]
      if (sortedArray.length > 1) {
        sortedArray.sort(function (a, b) {
          if (a.dateCreated < b.dateCreated) {
            return -1
          }
          if (a.dateCreated > b.dateCreated) {
            return 1
          }
          return 0
        })
      }
      return sortedArray
    },
    currentUserFullname () {
      if (!this.currentUser) {
        return ''
      }

      const { firstname, lastname } = this.currentUser

      return `${firstname} ${lastname}`
    },

    dummyReply () {
      return {
        author: this.currentUser,
        text: '',
        isDummy: true
      }
    }
  },

  methods: {
    async submitReply (payload) {
      const workflowId = this.$route.params.id
      const cardId = this.cardId
      await store.dispatch('workflow/addCardReply', {
        workflowId,
        cardId,
        input: {
          text: payload.text,
          generatedByAi: false
        }
      })
      this.$emit('hide-reply-form')
      if (payload.generatedByAi) {
        this.$emit('ask-for-reply', { text: payload.text, cardId, workflowId })
      }
    }
  }
}
</script>

<style scoped>
.expand-icon {
  transition: transform 0.3s ease-in-out;
}

.expand-icon.expanded {
  transform: rotate(180deg);
}
</style>
